module.exports = __webpack_public_path__ + "src/assets/img/70_years_welcome.fdb9ce73.svg";